import React, { useState, useEffect } from 'react'
import Classes from './Table.module.css'
import { useSelector } from 'react-redux';
import { Pagination, Stack } from '@mui/material';
import TableRow from './TableRow';
import { useNavigate } from 'react-router-dom';
import useScreenWidth from '../../../../../../../Hooks/useScreenWidth';

export default function Table() {
    const initialOrders = [
        { id: 1, order: "SEO", person: "John Smith", status: "Submitted", created: "06/1" },
        { id: 2, order: "UI/UX", person: "Brandon Smith", status: "Working", created: "07/3" },
        { id: 3, order: "Front-end", person: "Jeff Smith", status: "Canceled", created: "02/4" },
        { id: 4, order: "Back-end", person: "Hannah Smith", status: "Submitted", created: "03/5" },
    ];

    const [loading, setLoading] = useState(true);
    const navigateTo = useNavigate();
    const screenWidth = useScreenWidth();
    const isMobile = screenWidth <= 480;

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 8;

    const totalPages = Math.ceil(initialOrders.length / itemsPerPage);
    const currentItems = initialOrders.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );
    const startItem = (currentPage - 1) * itemsPerPage + 1;
    const endItem = Math.min(currentPage * itemsPerPage, initialOrders.length);
    const totalItems = initialOrders.length;

    function handlePageChange(e, pageNum) {
        setCurrentPage(pageNum);
    }

    const handleAddOrder = () => {
        navigateTo('/add-order');
    }

    return (
        <div className={Classes.table} >
            <div className={Classes.tableWrapper}>

                <div className={Classes.tableHeader}>
                    <div className={`${Classes.headerItem} ${Classes.headerCustomer}`}>
                        <h5>Order</h5>
                    </div>
                    <div className={`${Classes.headerItem} ${Classes.headerSpendings}`}>
                        <h5>Amount</h5>
                    </div>
                    <div className={`${Classes.headerItem} ${Classes.headerBookings}`}>
                        <h5>Status</h5>
                    </div>
                    <div className={`${Classes.headerItem} ${Classes.headerDate}`}>
                        <h5>Due</h5>
                    </div>
                </div>

                {currentItems.map((cust, idx) => (
                    <TableRow
                        key={cust._id}
                        value={cust}
                        index={idx}
                    />
                ))}

            </div>
        </div>
    )
}
